
<div class="flex">
  @if (dashboardService.loadingReviewsStats || showLoader) {
    <div class="loading-div">
      @if (dashboardService.loadingReviewsStats) {
        <mat-spinner diameter="80" class='full-center-spinner'></mat-spinner>
      }
    </div>
  }

  <div class="flex-item">
    <div class="chart-container">
      @if (chartData) {
        <canvas baseChart
          [data]="chartData"
          [options]="barChartOptions"
          [legend]="barChartLegend"
          [type]="barChartType"
        ></canvas>
      }
    </div>
  </div>
</div>